import options from './live-proximity-card.component';

export default {
    selector: 'dtLiveProximityCard',
    options
};
